// SPDX-FileCopyrightText: 2017-2022 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

import styled from 'styled-components'

import { AsyncButton } from '../../atoms/buttons/AsyncButton'

export const InlineAsyncButton = styled(AsyncButton)`
  padding: 0;
  min-width: 0;
  min-height: 0;
  border: none;
`
